import DealerReviewComparision from "../../../Components/Table/DealerReviewComparision";

const Offtake_Comparision = () => {
  return (
    <div className="bg-white shadow-lg text-xs rounded-lg w-full relative h-full">
      <h2 className="text-lg font-bold text-gray-800  p-2 pb-0">
        Offtake Comparision
      </h2>
      <DealerReviewComparision
        endpoint="dealer-review/offtake_comparision"
        expansionEndpoint="dealer-review/offtake_lob_wise_comparision"
      />
    </div>
  );
};

export default Offtake_Comparision;
